@if (form) {
    <div [formGroup]="form">
        <sirius-textarea
            [name]="name"
            [id]="id"
            [label]="label"
            [formControlName]="name"
            [identifier]="identifier"
            [toolTip]="toolTip"></sirius-textarea>
    </div>
}
